// Aнимация увеличение при скролле

function applyScrollScale(className) {
const elements = document.querySelectorAll(`.${className}`);


function updateScale() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;

    elements.forEach(el => {
    const scaleFactor = 1 + Math.min(scrollY / 5000, 0.2); 
    el.style.transform = `scale(${scaleFactor})`;
    });

    requestAnimationFrame(updateScale);
}

    window.addEventListener('scroll', updateScale);
}

applyScrollScale('scaleup');

// Анимация элемента вверх при скролле

function applyScrollTransformUp(className) {
  const elements = document.querySelectorAll(`.${className}`);

  function updateTransform() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const maxScroll = 500;
    const progress = Math.min(scrollY / maxScroll, 1);

    elements.forEach(el => {
      const baseTransform = `translate(-50%, ${progress * -5}rem)`;

      el.style.transition = '.4s ease';
      el.style.transform = baseTransform;
      el.style.opacity = 1 - progress;
      el.style.setProperty('will-change', 'transform');
    });

    requestAnimationFrame(updateTransform);
  }

  window.addEventListener('scroll', updateTransform);
}

applyScrollTransformUp('transform-up');

// Появление элемента при скролле

let FadeInOut = document.querySelectorAll('.fade-in-out');

FadeInOut.forEach((element) => {
    element.style.opacity = '0';
    element.style.transform = 'translateY(-10%)';
    element.style.transition = '1s ease'
});

const observerFadeInOut = new IntersectionObserver(entries => {
      entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = 1;
      entry.target.style.transform = 'translateY(0%)'
      observerFadeInOut.unobserve(entry.target);
    }
  });
}, {  threshold: 0.5 });

FadeInOut.forEach(element => observerFadeInOut.observe(element));

// Появление элемента снизу вверх при скролле

const fadeInUpElements = document.querySelectorAll('.fade-in-up');

fadeInUpElements.forEach((element) => {
  element.style.opacity = '0';
  element.style.transform = 'translateY(10%)';
  element.style.transition = 'transform 1s ease, opacity 1s ease';
});

const observerFadeInUp = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      const element = entry.target;

      const handleTransitionEnd = (event) => {
        if (
          event.target !== element ||
          event.propertyName !== 'transform'
        ) {
          return;
        }

        element.style.removeProperty('opacity');
        element.style.removeProperty('transform');
        element.style.removeProperty('transition');
        element.classList.remove('fade-in-up');

        element.removeEventListener(
          'transitionend',
          handleTransitionEnd
        );
      };

      element.addEventListener(
        'transitionend',
        handleTransitionEnd
      );

      element.style.opacity = '1';
      element.style.transform = 'translateY(0)';

      observerFadeInUp.unobserve(element);
    });
  },
  {
    threshold: 0.1,
  }
);

fadeInUpElements.forEach((element) => {
  observerFadeInUp.observe(element);
});

// Появление элемента справо на лево при скролле

let fadeInLeftElements = document.querySelectorAll('.fade-in-left');

fadeInLeftElements.forEach((element) => {
  element.style.opacity = '0';
  element.style.transform = 'translateX(-15%)';
  element.style.transition = 'transform 1s ease, opacity 1s ease';
});

const observerFadeInLeft = new IntersectionObserver(entries => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.style.opacity = '1';
      entry.target.style.transform = 'translateY(0)';
      observerFadeInLeft.unobserve(entry.target);
    }
  });
}, { threshold: 0.1 });

fadeInLeftElements.forEach(element => observerFadeInLeft.observe(element));


const swiperSlideUpItems = document.querySelectorAll('.home-gallery__item');

swiperSlideUpItems.forEach((item, index) => {
  item.style.opacity = '0';
  item.style.transform = 'translateY(40px)';
  item.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
});

const observerSwiperItems = new IntersectionObserver((entries, obs) => {
  entries.forEach((entry, index) => {
    if (entry.isIntersecting) {
      const el = entry.target;
      const delay = [...swiperSlideUpItems].indexOf(el) * 200; 

      setTimeout(() => {
        el.style.opacity = '1';
        el.style.transform = 'translateY(0)';
      }, delay);

      obs.unobserve(el); 
    }
  });
}, {
  threshold: 0.3
});

swiperSlideUpItems.forEach(item => observerSwiperItems.observe(item));

// Анимация подсчет для блока о Компании

const counters = document.querySelectorAll('.about__features__number, .about__title__number');
const duration = 3000;

const animateCount = (el, endValue) => {
  let startTime = null;

  const step = timestamp => {
    if (!startTime) startTime = timestamp;
    const progress = timestamp - startTime;
    const value = Math.min(Math.floor((progress / duration) * endValue), endValue);
    el.textContent = value;

    if (value < endValue) {
      requestAnimationFrame(step);
    }
  };

  requestAnimationFrame(step);
};

const observerNumbers = new IntersectionObserver((entries, obs) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const el = entry.target;
      const endValue = parseInt(el.textContent, 10);

      animateCount(el, endValue);
      obs.unobserve(el);
    }
  });
}, {
  threshold: 0.5 
});

counters.forEach(counter => observerNumbers.observe(counter));


if (document.querySelector('.about') && document.querySelector('.about__bg-image')) {
  const aboutSection = document.querySelector('.about');
  const bgImage = document.querySelector('.about__bg-image');
  let animationTriggered = false;

  const animateBgImage = () => {
    bgImage.style.transform = 'translateX(0)';
    bgImage.style.opacity = '1';
    bgImage.style.transition = 'transform 0.8s ease-out, opacity 0.8s ease-out';
  };

  const checkPosition = () => {
    const rect = aboutSection.getBoundingClientRect();
    if (!animationTriggered && rect.top <= 0) {
      animateBgImage();
      animationTriggered = true;
      window.removeEventListener('scroll', checkPosition);
    }
  };

  bgImage.style.transform = 'translateX(100%)';
  bgImage.style.opacity = '0';

  window.addEventListener('scroll', checkPosition);
}

// Анимация Ripple

document.querySelectorAll(".ripple-animation").forEach(button => {
  let isAnimating = false;

  button.addEventListener("mouseenter", function (event) {
    if (isAnimating) return;

    isAnimating = true;

    const rect = button.getBoundingClientRect();
    const diameter = Math.max(rect.width, rect.height);
    const radius = diameter / 2;

    const x = event.clientX - rect.left - radius;
    const y = event.clientY - rect.top - radius;

    const ripple = document.createElement("span");
    ripple.classList.add("ripple");

    ripple.style.width = ripple.style.height = `${diameter}px`;
    ripple.style.left = `${x}px`;
    ripple.style.top = `${y}px`;

    button.appendChild(ripple);

    ripple.addEventListener("animationend", () => {
      ripple.remove();
      isAnimating = false;
    });
  });
});